import { useClientData } from '../client/hooks/useClientData';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { useAgentInfo } from '../../../util/hooks';
import { DataSource, Root } from '@insurgrid/common';
import { useNavUtils } from './useNavUtils';
import { useClientQuestionsNav } from '../client/hooks/useClientQuestionsNav';
import { PATH } from '../../../paths';
import querystring from 'query-string';

export function useReturnToStep() {
  const { data: client, isLoading: clientLoading } = useClientData();
  const {
    showAcceleratedUnderwriting,
    agentLoading,
    showDisplayDriversQuestions,
    showDisplayPropertyQuestions,
  } = useAgentInfo();
  const { personal, occupation } = useClientQuestionsNav();
  const { generatePath } = useNavUtils();
  const { push } = useRouter();
  const searchParams = useSearchParams();

  const shouldReturnToStep =
    client &&
    searchParams.get('returnToStep') === 'true' &&
    client.data.clientSubmissions.length &&
    showAcceleratedUnderwriting &&
    !agentLoading;

  useEffect(() => {
    let path = generatePath(PATH.LANDING);
    if (shouldReturnToStep) {
      if (
        !(
          client.data.gender &&
          client.data.maritalStatus &&
          client.data.phone &&
          client.data.email
        )
      ) {
        path = generatePath(personal.path);
      } else if (
        !(
          client.data.educationLevel ||
          client.data.occupation ||
          client.data.industry
        )
      ) {
        path = generatePath(occupation.path);
      } else if (
        showDisplayDriversQuestions &&
        !client.data.clientStatedTheyHaveNoDrivers &&
        !client.data.drivers.filter(
          (driver) => driver.source === DataSource.ClientEntry,
        ).length
      ) {
        path = generatePath(PATH.AU_ROOT, {
          root: Root.Driver,
        });
      } else if (
        showDisplayPropertyQuestions &&
        !client.data.clientStatedTheyHaveNoDwellings &&
        !client.data.dwellings.filter(
          (dwelling) => dwelling.source === DataSource.ClientEntry,
        ).length
      ) {
        path = generatePath(PATH.AU_ROOT, {
          root: Root.Property,
        });
      }
      const queryFreePath = querystring.exclude(path, ['returnToStep']);
      push(queryFreePath);
    }
  }, [client]);

  return {
    submissions: client?.data.clientSubmissions,
    isLoading: clientLoading || shouldReturnToStep,
  };
}
